<template>
    <div class="resetCon">
        <div class="searchBox">
            <el-input
                placeholder="请输入内容"
                prefix-icon="el-icon-search"
                v-model="value">
            </el-input>
            <el-button type="primary" plain @click="searchList">搜索</el-button>
        </div>
        <div v-show="list.length != 0" class="listHead">
            <p>昵称</p>
            <p>账号</p>
            <p>操作</p>
        </div>
        <ul v-show="list.length != 0">
            <li v-for="(item, index) in list" :key="index">
                <p>{{ item.nickname }}</p>
                <p>{{ item.username }}</p>
                <p @click="resetPwd(item.username)">重置</p>
            </li>
        </ul>
        <pager :total-page="totalPage" :initPage="pageNum" @go-page="goPageNum" v-if="isShowPager" />
        <dialogBox v-if="isShowDialog" :value="password" @close-dialog="closeDialog" />
    </div>
</template>
<script>
import pager from '../pager.vue'
import dialogBox from '../dialog.vue'
export default {
    components: {
        pager,
        dialogBox
    },
    data() {
        return {
            value: "",
            pageNum: 1,
            totalPage: 1,
            isShowPager: false,
            list: [],
            isShowDialog: false,
            password: ""
        }
    },
    mounted() {

    },
    methods: {
        searchList() {
            let that = this;
            let data = {
                page: that.pageNum,
                size: 10,
                search: {
                    search: that.value
                }
            }
            that.allApi.audienceList(data).then((resource)=>{
                if( resource.data.code == 200 ) {
                    that.list = resource.data.data.list;
                    that.pageNum = resource.data.data.page;
                    if( that.pageNum == 1 ) {
                        that.totalPage = resource.data.data.pages;
                        if( that.totalPage > 1 ) {
                            that.isShowPager = true;
                        }else{
                            that.isShowPager = false;
                        }
                    }
                }else if( resource.data.code == 401 ){
                    that.$router.push("/")
                }
            })
        },
        resetPwd(userName) {
            let that = this;
            let data = new FormData();
            data.append("username", userName);
            that.allApi.resetPwd(data).then((resource)=>{
                if( resource.data.code == 200 ) {
                    that.password = resource.data.data;
                    that.isShowDialog = true;
                }else if( resource.data.code == 401 ){
                    that.$router.push("/")
                }
            })
        },
        goPageNum(obj) {
            let that = this;
            that.pageNum = obj.page;
            that.searchList();
        },
        closeDialog(boolean){
            let that = this;
            console.log(boolean)
            that.isShowDialog = boolean;
        }
    }
}
</script>
<style lang="scss" scoped>
    .resetCon{
        .searchBox{
            display: flex;
        }
        .listHead{
            display: flex;
            line-height: 40px;
            font-size: 20px;
            border-bottom: 1px solid #000;
            color: #666;
            background: #eee;
            margin-top: 30px;
            >p{
                text-align: center;
                flex: 1;
            }
        }
        >ul{
            margin-bottom: 30px;
            >li{
                display: flex;
                line-height: 40px;
                font-size: 20px;
                border-bottom: 1px solid #000;
                color: #666;
                >p{
                    text-align: center;
                    flex: 1;
                    &:last-child{
                        color: #1EA9E2;
                        cursor: pointer;
                    }
                }
            }
        }
    }
</style>
